import dayjs from 'dayjs'
const quarterOfYear = require('dayjs/plugin/quarterOfYear')
const isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(quarterOfYear)
dayjs.extend(isBetween)

export default (Vue) => {
  Vue.prototype.$dayjs = dayjs
}
